var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.189,
    height: 15.868,
    viewBox: "0 0 23.189 15.868",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_362",
    "data-name": "Group 362",
    transform: "translate(-1564.817 -128.29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M26.308,9.915a.411.411,0,0,0-.036-.145.358.358,0,0,0-.088-.117l-4.431-3a.368.368,0,0,0-.412.61l3.4,2.291h-12.7a.368.368,0,0,0,0,.736h12.8l-3.354,2.523a.369.369,0,0,0-.073.515.368.368,0,0,0,.515.073l4.244-3.192.039-.038a.343.343,0,0,0,.066-.1l.007-.015a.254.254,0,0,0,.021-.09l.006-.031Z",
    transform: "translate(1561.447 126.494)",
    fill: "#162ca1",
    stroke: "#162ca1",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M7.685,14.678a6.994,6.994,0,1,1,6.753-8.789h.711A7.673,7.673,0,1,0,15.04,9.9h-.727a7,7,0,0,1-6.629,4.778",
    transform: "translate(1565.067 128.54)",
    fill: "#162ca1",
    stroke: "#162ca1",
    strokeWidth: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.c435a3e393fa393d519187b59230cdba.svg";
export { ForwardRef as ReactComponent };